import React, { useState, useEffect } from 'react'
import { Grid, GridContainer, GridCell, ActionLink } from 'common-controls/Core/index'
import { sh, ReduxWrapper, compose } from 'common-data/datahelpers'
import _ from 'common-tools/LodashHelper'

export const LayoutContentMenu = compose(
  ReduxWrapper([
    sh.LayoutContentMenus,
    sh.CurrentRouteInfo
  ])
)(function LayoutContentMenuPlain (props) {
  const { LayoutContentMenus, CurrentRouteInfo, children } = props

  const [contentMenus, setContentMenus] = useState(new Map())

  useEffect(() => {
    let menus = _.sortBy(LayoutContentMenus.get(CurrentRouteInfo.pathname) || [], [(m) => { return m.index || 1 }])
    setContentMenus(menus)
  }, [LayoutContentMenus, CurrentRouteInfo])

  return (
    <GridContainer full className='hed-section-pad'>
      <Grid paddingX className='align-top'>
        <GridCell small={5} className="hedtitle">
          {children}&nbsp;
        </GridCell>
        <GridCell small={7} className="text-right hed-control-nav">
          {_.map(contentMenus, (m, i) => {
            const { id, onClick, toolTip } = m
            if (i === 0) {
              return <ActionLink key={id} onClick={onClick}>{toolTip}</ActionLink>
            } else {
              return <>&nbsp;|&nbsp;<ActionLink key={id} onClick={onClick}>{toolTip}</ActionLink></>
            }
          })}
        </GridCell>
      </Grid>
    </GridContainer>
  )
})
